module.exports = __webpack_public_path__ + "img/banner.120bf309.png";